const b = (e) => {
  if (typeof e != "string" && !(e instanceof String))
    return e;
  const t = [
    "®",
    "™",
    "℠",
    "°"
  ], n = {
    ē: "e",
    í: "i",
    ü: "u",
    ū: "u"
  };
  let a = e;
  return t.forEach((o) => {
    a = a.replace(new RegExp(o, "g"), "");
  }), Object.keys(n).forEach((o) => {
    a = a.replaceAll(o, n[o]);
  }), a;
}, v = (e) => e.substring(0, 100).replace(/[^A-Za-z1-9\-_:%\s]/g, ""), S = ["tealium_event"], z = "NA", P = [
  "affiliation",
  "cm_campaign",
  "cm_content",
  "cm_medium",
  "cm_source",
  "cm_term",
  "country_code",
  "currency_code",
  "employee_flag",
  "item_list_id",
  "item_list_name",
  "language_code",
  "login_status",
  "order_discount",
  "order_locale",
  "order_subtotal",
  "order_total",
  "page_category",
  "page_name",
  "page_subcategory",
  "page_type",
  "shipping",
  "site_section",
  "tax",
  "total_product_types",
  "total_quantity",
  "transaction_id",
  "url_clean",
  "value"
], p = () => {
  var e, t, n;
  return (e = window == null ? void 0 : window.utag_data) != null && e.single_instance_variables && Array.isArray((t = window == null ? void 0 : window.utag_data) == null ? void 0 : t.single_instance_variables) ? (n = window == null ? void 0 : window.utag_data) == null ? void 0 : n.single_instance_variables : P;
}, l = () => {
  var e, t;
  return (e = window == null ? void 0 : window.utag_data) != null && e.unavailable_data_placeholder ? (t = window == null ? void 0 : window.utag_data) == null ? void 0 : t.unavailable_data_placeholder : z;
}, y = () => {
  var e, t, n;
  return (e = window == null ? void 0 : window.utag_data) != null && e.array_exclusions && Array.isArray((t = window == null ? void 0 : window.utag_data) == null ? void 0 : t.array_exclusions) ? (n = window == null ? void 0 : window.utag_data) == null ? void 0 : n.array_exclusions : S;
}, x = (e) => Object.fromEntries(
  Object.entries(e).map(([t, n]) => {
    if (y().includes(t))
      return [t, n];
    if (p().includes(t)) {
      const o = Array.isArray(n) ? n[0] : n;
      return [t, o ? [String(o)] : []];
    }
    const a = Array.isArray(n) ? n.flat(1 / 0).map(String) : [String(n)];
    return [t, a];
  })
), I = (e, t) => e.map(([n, a]) => {
  if (!p().includes(n) && !y().includes(n) && (a == null ? void 0 : a.length) < t && (a == null ? void 0 : a.length) === 1) {
    const o = Array.from({ length: t }, () => a[0]).flat(1);
    return [n, o];
  }
  return [n, a];
}), f = (e) => Array.isArray(e) ? e.map((t) => t.toUpperCase()) : [], V = (e) => e.replace(/^\/[a-z]{2}-[A-Z]{2}/, ""), r = (e) => {
  var t;
  return (t = window == null ? void 0 : window.utag_data) != null && t[e] ? [window.utag_data[e]] : [l()];
}, O = () => {
  var e;
  return (e = window == null ? void 0 : window.utag_data) != null && e.affiliation ? r("affiliation") : ["Web Store"];
}, L = (e) => {
  try {
    const t = new URL(e), n = V((t == null ? void 0 : t.pathname) || "");
    return [`${t.origin}${n}`];
  } catch (t) {
    return console.warn(t), l();
  }
}, j = (e) => {
  const n = document.cookie.split("; ").find((a) => a.startsWith(`${e}=`));
  return n ? n.split("=")[1] : null;
}, g = (e) => {
  const t = new URLSearchParams(window.location.search);
  return t.get(e) ? [v(t.get(e))] : [l()];
}, C = (e) => e === "1" ? "Logged In" : "Logged Out", U = () => document != null && document.title ? [b(document.title)] : [l()], H = (e = {}) => ({
  ...e,
  affiliation: e.affiliation ?? O(),
  country_code: e.country_code ?? r("country_code"),
  cm_campaign: e.cm_campaign ?? g("utm_campaign"),
  cm_content: e.cm_content ?? g("utm_content"),
  cm_medium: e.cm_medium ?? g("utm_medium"),
  cm_source: e.cm_source ?? g("utm_source"),
  cm_term: e.cm_term ?? g("utm_term"),
  currency_code: e.currency_code ?? r("currency_code"),
  language_code: e.language_code ?? r("language_code"),
  login_status: e.login_status ?? C(j("GARMIN-SSO")),
  page_category: e.page_category ?? r("page_category"),
  page_name: e.page_name ?? U(),
  page_subcategory: e.page_subcategory ?? r("page_subcategory"),
  page_type: e.page_type ?? r("page_type"),
  url_clean: e.url_clean ?? L(document.location.toString())
}), _ = (e) => {
  var d;
  const t = H(e), n = x(t);
  n != null && n.country_code && (n.country_code = f(n.country_code)), n != null && n.language_code && (n.language_code = f(n.language_code));
  const a = Object.entries(n), o = Math.max.apply(
    Math,
    a.map(([s, w]) => !p().includes(s) && !y().includes(s) ? w.length : 0)
  ), i = o > 1 ? I(a, o) : a, c = Object.fromEntries(i);
  return (d = window == null ? void 0 : window.utag_data) != null && d.enableGarminAnalyticsDebug && console.log({ analyticsData: c }), c;
}, K = (e) => {
  var t;
  (t = window == null ? void 0 : window.utag) != null && t.link ? e ? window.utag.link(_(e)) : console.warn("No data passed to sendAnalyticsEvent") : console.warn("window.utag.link is undefined");
}, Q = (e) => {
  var t;
  (t = window == null ? void 0 : window.utag) != null && t.view ? e ? window.utag.view(_(e)) : console.warn("No data passed to sendAnalyticsPageView") : console.warn("window.utag.view is undefined");
};
let m, E;
const N = [], u = Object.freeze({
  VIEW: "view",
  LINK: "link"
}), R = {
  [u.VIEW]: {},
  [u.LINK]: {}
}, k = () => {
  var e, t;
  return !!((e = window.utag) != null && e.view) && !!((t = window.utag) != null && t.link);
}, G = () => {
  var t, n;
  if (m)
    return m;
  const e = E ?? "www.garmin.com";
  return ((t = window == null ? void 0 : window.location) == null ? void 0 : t.host) === e ? ["config", (n = window == null ? void 0 : window.utag_data) == null ? void 0 : n.GA4_ID] : [
    "config",
    "G-K5X2MQK80V",
    { debug_mode: !0 }
  ];
}, A = () => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push(["js", /* @__PURE__ */ new Date()]), window.dataLayer.push(G());
}, M = () => {
  N.forEach((e) => {
    window.utag[e.utagAnalyticsType](e.sanitizedPayload);
  });
}, T = (e) => Object.keys(e).reduce((n, a) => {
  const o = e[a];
  return Object.defineProperty(n, a, {
    value: b(o),
    enumerable: !0
  }), n;
}, {}), h = (e, t) => {
  const n = T(_({
    ...R[t],
    ...e
  }));
  k() ? window.utag[t](n) : N.push({ utagAnalyticsType: t, sanitizedPayload: n });
}, W = (e) => {
  const { dataLayer: t, host: n } = e ?? { dataLayer: void 0, host: void 0 };
  m = t, E = n, k() ? A() : window.addEventListener("utag-ready", () => {
    A(), M();
  });
}, B = {
  /**
   * @description Checks the bindings and either fires a page view event
   * or applies a click event listener to fire when the user clicks.
   * Called when the bound element's parent component and all its children are mounted.
   * @param {Element} element The HTML element with the v-utag-event attribute
   * @param {object} binding The object passed to the v-utag-event directive
   */
  mounted: (e, t) => {
    const { value: n } = t ?? { value: {} };
    (n == null ? void 0 : n.event_action) === "click" && (e != null && e.addEventListener) ? e.addEventListener("click", () => h(n, u.LINK)) : h(n, u.VIEW);
  }
}, F = {
  /**
   * @description Adds a custom event listener to the element that the directive is added to and listens
   * for click events and matches where the event.target is an anchor element. Then calls the utag.link
   * function with the values passed to the v-utag-link-handler-event directive.
   *
   * Called when the bound element's parent component and all its children are mounted.
   * @param {Element} element The HTML element with the v-utag-link-handler-event attribute
   * @param {object} binding The object passed to the v-utag-link-handler-event directive
   */
  mounted: (e, t) => {
    const { value: n = {} } = t, a = (o) => {
      var d;
      let i = o == null ? void 0 : o.target, c;
      for (i.tagName.toLowerCase() === "a" && (c = (i == null ? void 0 : i.innerText) || "NA"), i.tagName.toLowerCase() === "img" && (c = i.getAttribute("alt") || "NA"); i !== o.currentTarget; ) {
        if (i.tagName.toLowerCase() === "a" && Object.keys(n).length && ((d = window == null ? void 0 : window.utag) != null && d.link)) {
          const s = { ...n }, w = i.getAttribute("href");
          s.url_clean = L(w), s.nav_label = c || "NA", window.utag.link(_(s));
          break;
        }
        i = i.parentElement;
      }
    };
    e.linkEventHandler = a, e.addEventListener("click", a);
  },
  unmounted: (e) => {
    e.removeEventListener("click", e.linkEventHandler), delete e.linkEventHandler;
  }
}, $ = "utag-event", Z = "utag-link-handler-event";
export {
  u as UtagAnalyticsType,
  k as checkIsUtagReady,
  S as defaultArrayExclusions,
  z as defaultNA,
  P as defaultSingleInstanceVars,
  G as getDataLayerConfig,
  T as getSanitizedAnalyticsPayload,
  W as initializeGA4,
  A as initializeGADataLayer,
  M as processEventQueue,
  b as sanitizeAnalyticsString,
  K as sendAnalyticsEvent,
  Q as sendAnalyticsPageView,
  h as sendAnalyticsPayload,
  R as utagAnalyticsBaseAttributes,
  B as utagDirective,
  $ as utagDirectiveName,
  F as utagLinkHandlerDirective,
  Z as utagLinkHandlerDirectiveName
};
